export default "__VITE_ASSET__3u446j$N__"